import React, { useState, useEffect } from "react";
import "../../css/Contact.css";
import BASE_URL from "../../config/config";
import Captcha from "../Auth/Captcha";
import FAQSection from "../template/FAQSection";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [submitMessage, setSubmitMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [csrfToken, setCsrfToken] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);

  // اطلاعات شرکت
  const companyInfo = {
    name: "هوش جدید",
    subtitle: "",
    email: "info@hooshjadid.ir",
    phone: "083-37223368",
    mobile: "09331187978",
    address:
      "کرمانشاه، خیابان دبیر اعظم، مجتمع تجاری کامپیوتری میرداماد، طبقه دوم، واحد 114",
    postalCode: "",
  };

  // لینک‌های شبکه‌های اجتماعی
  const socialLinks = {
    instagram: "https://instagram.com/hooshjadid",
    selfInstagram: "https://instagram.com/tarahe.website",
    telegram: "https://t.me/WebsiteDeveloper",
    whatsapp:
      "https://wa.me/989331187978?text=سلام+از+سایت+هوش+جدید+پیام+می‌فرستم",
    aparat: "https://www.aparat.com/mosab.ir",
  };

  const heroContent = {
    title: `تماس با<br><span class="text-light block">${companyInfo.name} ${companyInfo.subtitle}</span>`,
    description: `ما همیشه آماده پاسخگویی به سوالات شما هستیم<br class="hidden md:block">با ما در ارتباط باشید و مسیر یادگیری خود را آغاز کنید`,
  };

  const contactCards = [
    {
      icon: "📞",
      title: "تماس تلفنی",
      info: companyInfo.phone,
      description: "شنبه تا پنج‌شنبه ۹ تا ۲۱",
    },
    {
      icon: "📱",
      title: "تماس موبایل",
      info: companyInfo.mobile,
      description: "پاسخگویی ۲۴ ساعته",
    },
    {
      icon: "📧",
      title: "ایمیل",
      info: companyInfo.email,
      description: "پاسخ در کمتر از ۲۴ ساعت",
    },
    {
      icon: "📍",
      title: "آدرس دفتر",
      info: companyInfo.address,
      description: "بازدید با هماهنگی قبلی",
    },
  ];

  const officeHours = [
    { day: "شنبه تا چهارشنبه", time: "۹:۰۰ - ۲۱:۰۰", icon: "🕘" },
    { day: "پنج‌شنبه", time: "۹:۰۰ - ۱۹:۰۰", icon: "🕐" },
    { day: "جمعه", time: "تعطیل", icon: "🚫" },
    { day: "پشتیبانی آنلاین", time: "۲۴/۷", icon: "💬" },
  ];

  const faqContent = [
    {
      question: "چگونه می‌توانم در دوره‌ها ثبت‌نام کنم؟",
      answer:
        "برای ثبت‌نام در دوره‌ها، می‌توانید از طریق سایت اقدام کنید یا با شماره تماس ما تماس بگیرید.",
    },
    {
      question: "آیا امکان بازپرداخت وجود دارد؟",
      answer:
        "بله، ما ضمانت بازگشت وجه تا 24 ساعت پس از شروع دوره ارائه می‌دهیم.",
    },
  ];

  // دریافت CSRF Token
  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await fetch(`${BASE_URL}/csrf-token`, {
          credentials: "include",
        });
        const data = await response.json();
        if (data.csrfToken) {
          setCsrfToken(data.csrfToken);
        } else {
          console.error("CSRF token not received!");
        }
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };
    fetchCsrfToken();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!captchaVerified) {
      setSubmitMessage("لطفاً کد امنیتی را تأیید کنید.");
      return;
    }

    setIsLoading(true);
    setSubmitMessage("");

    try {
      const fullName = `${formData.firstName} ${formData.lastName}`.trim();
      const payload = {
        name: fullName,
        email: formData.email,
        phone: formData.phone,
        subject: formData.subject,
        message: formData.message,
      };

      const response = await fetch(`${BASE_URL}/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "CSRF-Token": csrfToken,
        },
        body: JSON.stringify(payload),
        credentials: "include",
      });

      if (response.ok) {
        setSubmitMessage("پیام شما با موفقیت ارسال شد. با تشکر!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          subject: "",
          message: "",
        });
        setCaptchaVerified(false);
      } else {
        const data = await response.json();
        setSubmitMessage(data.message || "خطایی در ارسال پیام رخ داد.");
      }
    } catch (error) {
      setSubmitMessage("خطایی رخ داد. لطفاً دوباره تلاش کنید.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="hero-bg py-15 md:py-32 px-5 hero-section-cantact">
        <div className="text-center">
          <h1
            className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight"
            dangerouslySetInnerHTML={{ __html: heroContent.title }}
          />
          <p
            className="text-xl md:text-2xl text-white opacity-95 mb-8 max-w-4xl mx-auto leading-relaxed"
            dangerouslySetInnerHTML={{ __html: heroContent.description }}
          />
        </div>
      </section>

      {/* Contact Information Cards */}
      <section className="py-20 bg-white px-5">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold gradient-text mb-4">
            راه‌های تماس
          </h2>
          <p className="text-gray-600 text-lg">با ما در ارتباط باشید</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {contactCards.map((card, index) => (
            <div className="p-6 rounded-lg shadow-lg bg-white" key={index}>
              <div className="text-4xl mb-4">{card.icon}</div>
              <h3 className="text-xl font-bold text-dark mb-2">{card.title}</h3>
              <p className="text-primary font-semibold mb-2">{card.info}</p>
              <p className="text-gray-600 text-sm">{card.description}</p>
            </div>
          ))}
        </div>

        {/* Social Media Links */}
        <div className="flex justify-center gap-6 mt-10">
          <a
            href={socialLinks.telegram}
            target="_blank"
            rel="noopener noreferrer"
            className="text-lg text-blue-600 hover:text-blue-800"
          >
            تلگرام
          </a>
          <a
            href={socialLinks.whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="text-lg text-green-600 hover:text-green-800"
          >
            واتس‌اپ
          </a>
          <a
            href={socialLinks.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="text-lg text-pink-600 hover:text-pink-800"
          >
            اینستاگرام
          </a>
        </div>
      </section>

      {/* Contact Form & Map */}
      <section className="py-20 bg-light px-5">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Form */}
          <div>
            <div className="bg-white p-4 rounded-2xl shadow-lg">
              <h3 className="text-2xl font-bold gradient-text mb-6 text-center">
               سفارش خدمات، خرید دوره، سوالات یا درخواست پشتیبانی خود را از طریق فرم زیر ارسال کنید
              </h3>
              <form
                id="contactForm"
                className=""
                onSubmit={handleSubmit}
              >
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="form-group">
                    <label className="form-label" htmlFor="firstName">
                      نام *
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      className="form-input"
                      placeholder="نام خود را وارد کنید"
                      required
                      value={formData.firstName}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label" htmlFor="lastName">
                      نام خانوادگی *
                    </label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      className="form-input"
                      placeholder="نام خانوادگی خود را وارد کنید"
                      required
                      value={formData.lastName}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="email">
                    ایمیل *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    className="form-input"
                    placeholder="example@email.com"
                    required
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="phone">
                    شماره تماس
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="form-input"
                    placeholder="۰۹۱۲-۳۴۵۶۷۸۹"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="subject">
                    موضوع *
                  </label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    className="form-input"
                    placeholder="موضوع پیام خود را وارد کنید"
                    required
                    value={formData.subject}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="message">
                    پیام *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    className="form-input form-textarea"
                    placeholder="پیام خود را اینجا بنویسید..."
                    rows="4"
                    required
                    value={formData.message}
                    onChange={handleChange}
                  ></textarea>
                </div>


              
              {/* کپچای داخلی (مثل صفحه بازیابی رمز عبور) */}
              {/* <div className="captcha-container mb-4"> */}
              <Captcha
                onVerify={(isVerified) => setCaptchaVerified(isVerified)}
                onExpire={() => setCaptchaVerified(false)}
                timeout={120000}
                regenerateOnError={true}
              />
              {/* </div> */}

              {submitMessage && (
                <p
                  className={`text-sm mt-2 text-center ${submitMessage.includes("خطا") ||
                    !submitMessage.includes("با موفقیت")
                    ? "text-red-500"
                    : "text-green-500"
                    }`}
                >
                  {submitMessage}
                </p>
              )}
              <button
                type="submit"
                className="w-full btn-primary px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-lg"
                disabled={isLoading || !captchaVerified}
              >
                {isLoading ? "در حال ارسال..." : "📤 ارسال پیام"}
              </button>
              </form>
            </div>
          </div>
       
          {/* Map & Office Info */}
          <div className="space-y-8">
            <div className="map-container bg-white p-6 rounded-2xl shadow-lg">
              {/* Map & Office Info */}
              <div className="space-y-6">
                {/* Title */}
                <div className="text-center mb-4">
                  <h4 className="text-xl font-bold text-dark">
                    نقشه دفتر مرکزی
                  </h4>
                </div>

                {/* Google Maps Embed */}
                <div className="rounded-lg overflow-hidden shadow-lg border border-gray-200">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3410.347741551975!2d47.063139!3d34.305889!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDE4JzIxLjIiTiA0N8KwMDMnNDcuMyJF!5e0!3m2!1sfa!2s!4v1730000000000!5m2!1sfa!2s"
                    width="100%"
                    height="250"
                    style={{ border: 0, borderRadius: "0.5rem" }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="نقشه دفتر هوش جدید"
                  ></iframe>
                </div>

                {/* Address */}
                <p className="text-gray-700 text-center mt-4">
                  {companyInfo.address}
                </p>
                {companyInfo.postalCode && (
                  <p className="text-gray-500 text-center text-sm mt-1">
                    کد پستی: {companyInfo.postalCode}
                  </p>
                )}
              </div>
              {companyInfo.postalCode && (
                <p className="text-gray-500 mt-1">
                  کد پستی: {companyInfo.postalCode}
                </p>
              )}
            </div>

            {/* ساعت کاری */}
            <div className="bg-white p-6 rounded-2xl shadow-lg">
              <h4 className="text-xl font-bold text-dark mb-4 text-center">
                ساعات کاری
              </h4>
              <div className="space-y-3">
                {officeHours.map((hour, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
                  >
                    <span className="text-gray-600">{hour.time}</span>
                    <div className="flex items-center">
                      <span className="ml-2">{hour.icon}</span>
                      <span className="font-medium text-dark">{hour.day}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <div className="mt-5 mb-3">
        <FAQSection />
      </div>

      {/* CTA Section */}
      <section className="hero-bg py-20 px-5">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
            آماده شروع یادگیری هستید؟
          </h2>
          <p className="text-white text-xl mb-12 opacity-95 leading-relaxed">
            همین الان با ما تماس بگیرید و مسیر یادگیری خود را آغاز کنید
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">

            <button
              class="btn-secondary  border-white text-white px-5 py-3 rounded-xl font-bold text-xl hover:bg-white hover:text-primary transition-all shadow-xl"
            >
              <a href={`tel:${companyInfo.mobile}`}>
                📞 تماس فوری
              </a>
            </button>
            <button class="btn-primary px-4 py-3 rounded-xl font-bold text-xl transition-all shadow-xl">
              <a href={socialLinks.telegram} target="_blank" rel="noopener noreferrer">
                پیام در تلگرام
              </a>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
